/* eslint-disable no-unused-vars */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const removeProperty = (key: string) => ({ [key]: _, ...rest }) => rest;
